// localStorage persistence — draft auto-save, keyed by merchantId.

const STORAGE_PREFIX = 'proship.merchant.';

export function saveWizardState(merchantId, state) {
  if (!merchantId) return;
  // Defer off the render cycle — never block a stage transition.
  setTimeout(() => {
    try {
      // Strip fields that are large, already sent to the API, or re-fetchable so
      // JSON.stringify stays fast regardless of rate card size.
      const slim = {
        ...state,
        lastSavedAt: new Date().toISOString(),
        agreement: state.agreement
          ? { ...state.agreement, pdfDataUrl: undefined }
          : state.agreement,
        rateCard: state.rateCard
          ? { ...state.rateCard, rows: [], rowsSource: null }
          : state.rateCard,
        rvp: state.rvp
          ? { ...state.rvp, rows: [], extracted: { rates: null, slabKeys: null, source: 'manual' } }
          : state.rvp,
        serviceabilityGroups: [],
      };
      window.localStorage.setItem(STORAGE_PREFIX + merchantId, JSON.stringify(slim));
    } catch (e) {
      console.warn('Wizard state persist failed:', e);
    }
  }, 0);
}



export function loadWizardState(merchantId) {
  if (!merchantId) return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_PREFIX + merchantId);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function removeWizardState(merchantId) {
  try {
    window.localStorage.removeItem(STORAGE_PREFIX + merchantId);
  } catch {
    // no-op
  }
}

// Builds the minimal per-stage payload sent to the draft endpoint on each Next click.
// pdfDataUrl is excluded — it's too large for a regular JSON body; upload it separately.
export function buildStageDraft(stage, wizard) {
  const { merchantId } = wizard;
  switch (stage) {
    case 1:
      return {
        merchantId, stage,
        kyc: {
          overallStatus: wizard.kyc.overallStatus,
          submittedAt: wizard.kyc.submittedAt,
          docs: wizard.kyc.docs,
        },
      };
    case 2:
      return {
        merchantId, stage,
        profile: wizard.profile,
        warehouse: wizard.warehouse,
        resolvedServices: wizard.resolvedServices,
        masterInfo: wizard.masterInfo,
      };
    case 3:
      return {
        merchantId, stage,
        // strip the base64 PDF — only metadata persisted here
        agreement: { ...wizard.agreement, pdfDataUrl: undefined },
        credit: wizard.credit,
        arrangement: wizard.arrangement,
      };
    case 4:
      return {
        merchantId, stage,
        rateCard: wizard.rateCard,
        rateCardMode: wizard.rateCardMode,
        rvp: wizard.rvp,
      };
    case 5:
      return {
        merchantId, stage,
        tc: wizard.tc,
        rto: wizard.rto,
        invoice_ceiling: wizard.invoice_ceiling,
        effective_date: wizard.effective_date,
        effective_mode: wizard.effective_mode,
      };
    case 6:
      return {
        merchantId, stage,
        confirmations: wizard.confirmations,
      };
    default:
      return { merchantId, stage };
  }
}
